import { render } from "./SwdTypeUserLabel.vue?vue&type=template&id=76ae78b8"
import script from "./SwdTypeUserLabel.vue?vue&type=script&lang=js"
export * from "./SwdTypeUserLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__